// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function isString(value: any): boolean {
  return ((typeof value === 'string') || (value instanceof String));
}

export function temp(): number {
  return 0;
}
